import gql from 'graphql-tag';

export const GET_MERCHANT = gql`
  query GetMerchantsList($params: MerchantSearchInput) {
    merchantList(params: $params) {
      result {
        hasOnlineVenue
        hasNearbyVenue
      }
    }
  }
`;
